<template>
  <v-card-component :title="cardTitle" :icon="cardIcon">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium"> Blood Group <span
                class="error--text" v-if="required">*</span></span>
            <v-autocomplete v-model="value.bloodGroup" key="id" class="my-0 py-1"
              single-line placeholder="--Select--" label="---Select---" :items="bloodGroupList" :required="required"
              item-text="value" item-value="value">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">Serious accidents/illness/operations <span
                class="error--text " v-if="required">*</span></span>
            <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
              v-model="value.anySeriousAccidentsOrIllnessOrOperarions" :required="required"
              single-line>
            </v-text-field>
          </v-col>
          <v-col cols="12" lg="4" sm="6">
            <span class="body-2 font-weight-medium">Specify date of Serious accidents /
              operations</span>
            <custom-date-picker :maxToDate="maxToDate"
              v-model.trim="value.dateForSeriousAccidentsOrIllnessOrOperarions"
              />
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Any other aliment please specify <span
            class="error--text " v-if="required">*</span></span>
        <v-text-field type="text" placeholder="Other aliment, else write NA" class="my-0 py-1"
          v-model="value.anyOtherAliment" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Special care ( if required, please
          specify) <span class="error--text " v-if="required">*</span></span>

        <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
          v-model="value.specialCare" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Allergies/Asthma/Breathlessness <span
            class="error--text " v-if="required">*</span></span>
        <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
          v-model="value.allergiesOrAsthmaOrBreathlessness" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <h1><span class="warning--text"><b>Diagnostic & Medical Information</b></span></h1>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Identified food allergies, if any ( and
          treatment given normally ) <span class="error--text " v-if="required">*</span></span>

        <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
          v-model="value.foodAllergies" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Drug allergies, if any <br>( and treatment given
          normally ) <span class="error--text" v-if="required">*</span></span>

        <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
          v-model="value.drugAllergies" :required="required" single-line>
        </v-text-field>
      </v-col>
       <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Please upload images of any prescribed medication that your child is taking. <span class="error--text" v-if="required">*</span></span>
           <v-file-input
            :messages="['(max file size allowed 5MB)']"
            accept=".png,.jpeg"
            v-model="value.dropFile"
            multiple
            drag-drop
            @change="onFilechange()"
            show-size
            placeholder="Accepts png, jpeg only"
          ></v-file-input>
          <span v-if="value.prescribedMedication1.length > 0">
            <v-chip
                v-for="(file, i) in value.prescribedMedication1"
                :key="i"
                color="primary"
                label
                outlined
                class="ma-2"
                close
                @click:close="deleteDropFile1(file.id)"
              >
                {{ file.name }}
              </v-chip>
          </span>
      </v-col>
      <v-col cols="12" lg="8" sm="6">
        <span class="body-2 font-weight-medium">Does your child have any physical challenges,
          learning
          difficulties, special needs? If yes please mention detail <span
            class="error--text " v-if="required">*</span></span>

        <v-text-field type="text" placeholder="Specify if any, else write NA " class="my-0 py-1"
          v-model="value.anyPhysicalChallengeOrLearningDifficulties" :required="required"
          single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">What technique(s) do you usually use to
          discipline your child? <span class="error--text" v-if="required">*</span></span>
        <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
          v-model="value.techniqueToDisciplineYourChild" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">What is your child's usual reaction to being
          disciplined? <span class="error--text" v-if="required">*</span></span>
        <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
          v-model="value.childsUsualReactionToBeingDisciplined" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Does your child usually accept new people
          easily? <span class="error--text" v-if="required">*</span></span>
        <v-radio-group v-model="value.isNewPeopleEasilyAcceptable" mandatory row>
          <v-radio label="Yes" name="match" value="Yes" class="mr-7" :required="required">
          </v-radio>
          <v-radio label="No" name="match" value="No" class="mr-7" :required="required">
          </v-radio>
          <v-radio label="UnSure" name="match" value="UnSure">
          </v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12">
        <h1><span class="warning--text"><b>Particulars of General Physician/Family Doctor
              <span class="error--text" v-if="required">*</span></b></span></h1>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Name <span class="error--text" v-if="required">*</span></span>
        <v-text-field type="text" placeholder="Name" class="my-0 py-1"
          v-model="value.familyDoctorOrPhysicianName" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Qualification <span class="error--text" v-if="required">*</span></span>
        <v-text-field type="text" placeholder="Qualification, else NA" class="my-0 py-1"
          v-model="value.familyDoctorOrPhysicianQualification" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Practicing Clinic/Hospital details
          <span class="error--text" v-if="required">*</span></span>
        <v-text-field type="text" placeholder="Specify if any, else write NA" class="my-0 py-1"
          v-model="value.practicingClinicDetails" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Office Telephone</span>
        <span class="error--text" v-if="required">*</span>
        <v-text-field placeholder="Number" type="number" class="my-0 py-1"
          v-model="value.practicingClinicOfficeTelephone" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Mobile</span>
        <span class="error--text" v-if="required">*</span>
        <v-text-field placeholder="Number" type="number" class="my-0 py-1"
          onKeyPress="if(this.value.length==10) return false;"
          v-model="value.practicingClinicMobileNo" :required="required" single-line>
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Email Id <span class="error--text" v-if="required">*</span></span>
        <v-text-field placeholder="Email" type="email" class="my-0 py-1"
          v-model="value.practicingClinicEmailID" :required="required">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Chickenpox - Varicella Vaccine</span>

<v-text-field type="date" :max="maxToDate" class="my-0 py-1"
          v-model="value.chikenpoxVaricellaVaccineDate"></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Diptheria - DTap*Vaccine </span>

<v-text-field type="date" :max="maxToDate" class="my-0 py-1"
          v-model="value.diptheriaDTapVaccineDate"></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Haemophilus influenza Type B - HiB Vaccine
        </span>

<v-text-field type="date" :max="maxToDate" class="my-0 py-1"
          v-model="value.haemophilusInfluenzaTypeBHiBVaccineDate"></v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Hepatitis A - HepA Vaccine
        </span>
<v-text-field type="date" :max="maxToDate" class="my-0 py-1"
          v-model="value.hepatitisAHepAVaccineDate"></v-text-field>
           </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Hepatitis B - HepB Vaccine
        </span>
<v-text-field type="date" :max="maxToDate" class="my-0 py-1"
          v-model="value.hepatitisBHepBVaccineDate">
        </v-text-field>
      </v-col>
      <v-col cols="12" lg="4" sm="6">
        <span class="body-2 font-weight-medium">Tetanus - DTaP
        </span>
<v-text-field type="date" :max="maxToDate" class="my-0 py-1"
          v-model="value.tetanusDTapDate">
        </v-text-field>
      </v-col>
      <v-col cols="12">
        <h1><span class="warning--text"><b>*DTaP is a combination vaccine that protects against
              Dptheria, Tetanus & Pertussis.</b></span></h1>
      </v-col>
      <v-col cols="12">
        <h1><span class="warning--text"><b>*MMR is a combination vaccine that protects against
              Measles, Mumps & Rubella.</b></span></h1>
      </v-col>
    </v-row>
  </v-card-component>
</template>
<script>
import CustomDatePicker from '@/components/template/CustomDatePicker'
import VCardComponent from '@/components/template/VCardComponent'
import moment from 'moment'
import constants from '@/utils/constants'
export default {
  name: 'HealthElement',
  props: {
    formType: {
      default: '',
      type: String
    },
    value: {
      default: () => {},
      type: Object
    },
    isWritable: {
      default: 'false',
      type: String
    }
  },
  components: {
    CustomDatePicker,
    VCardComponent
  },
  data: function () {
    return {
      isReadonly: false,
      isDisabled: false,
      cardTitle: '',
      cardIcon: '',
      maxToDate: moment().format('YYYY-MM-DD'),
      required: true,
      bloodGrp: '',
      deleteFileIdArr: [],
      bloodGroupList: [
        {
          id: 0,
          value: 'A+'
        },
        {
          id: 1,
          value: 'A-'
        },
        {
          id: 2,
          value: 'B+'
        },
        {
          id: 3,
          value: 'B-'
        },
        {
          id: 4,
          value: 'O+'
        },
        {
          id: 5,
          value: 'O-'
        },
        {
          id: 6,
          value: 'AB+'
        },
        {
          id: 7,
          value: 'AB-'
        }
      ],
      allowedFiles: [
        'jpeg',
        'png'
      ]
    }
  },
  mounted () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
  },

  created () {
    if (this.isWritable === 'false') {
      this.isReadonly = true
      this.isDisabled = true
    }
    this.cardTitle = 'Health Details'
    this.cardIcon = 'mdi-account-heart'
    if (this.formType === 'edit_registration') {
      this.required = false
    }
    if (this.formType === 'registration') {
      this.required = false
    }
  },
  methods: {
    deleteDropFile (i) {
      this.value.dropFile.splice(i, 1)
    },
    deleteDropFile1 (docID) {
      this.$dialog.warning({
        title: 'Deleting File',
        text: '"Do you want to Delete this file"?',
        actions: {
          false: 'No',
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let payload = {
                  isActive: 'false'
                }
                await http.put(`${constants.API_URL}/api/edit-registrations-PrescribedDoc/v1/${docID}`, payload)
                console.log(`File with ID ${docID} deleted successfully`)
                location.reload()
                this.$dialog.info({
                  title: 'Success',
                  text: 'Deleted successfully'
                })
              } catch (error) {
                console.error('Error deleting file:', error)
              }
            }
          }
        }
      })
    },
    onFilechange () {
      let r = this.value.dropFile.some((a) => {
        return !this.allowedFiles.includes(a.name.split('.').pop())
      })
      if (r === true) {
        this.value.dropFile.pop()
        return this.$dialog.error({
          text: 'Kindly select allowed file formats only!',
          title: 'Error'
        })
      }
      if (this.value.dropFile.length > 10) {
        return this.$dialog.error({
          text: 'You are only allowed to upload a maximum of 10 files!',
          title: 'Error'
        })
      }
      if (this.value.dropFile) {
        this.value.dropFile.forEach((element) => {
          if (element.size === 0) {
            return this.$dialog.error({
              title: 'Error',
              text: 'The File size should be greater than 0'
            })
          }

          if (element.size > 5 * 1024 * 1024) {
            return this.$dialog.error({
              title: 'Error',
              text: 'Image size must be less than 5 MB!'
            })
          }
        })
      }
    }

  }
}
</script>
